/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceAccountGovernancePropagation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceAccountGovernancePropagation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceAccountGovernancePropagation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceAccountGovernancePropagation>): BackgroundJobPayloadForServiceAccountGovernancePropagation {
        let obj = Object.assign(new BackgroundJobPayloadForServiceAccountGovernancePropagation(), model);
        BackgroundJobPayloadForServiceAccountGovernancePropagation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceAccountGovernancePropagation>): BackgroundJobPayloadForServiceAccountGovernancePropagation {
        if (!model) return null;
        return BackgroundJobPayloadForServiceAccountGovernancePropagation.newInstance(<BackgroundJobPayloadForServiceAccountGovernancePropagation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceAccountGovernancePropagation) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceAccountGovernancePropagation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceAccountGovernancePropagation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceAccountGovernancePropagation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.previous_settings) {
            for (let val of this.previous_settings) {
                models.GovernanceConfigurationBase.fixupPrototype(val);
            }
        }
        if (this.settings) {
            for (let val of this.settings) {
                models.GovernanceConfigurationBase.fixupPrototype(val);
            }
        }
        if (this.target_settings) {
            for (let val of this.target_settings) {
                models.GovernanceConfigurationBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Governance Configuration settings before changes
     */
    previous_settings: Array<models.GovernanceConfigurationBase>;

    /**
     * Governance Configuration settings to apply
     */
    settings: Array<models.GovernanceConfigurationBase>;

    /**
     * Governance Configuration settings to apply
     */
    target_settings: Array<models.GovernanceConfigurationBase>;

    /**
     * If set, the intent is to just check that the configuration against the Cloud/Tool provider is still valid
     */
    periodic_check: boolean;

    /**
     * If set, the intent is to just validate the configuration against the Cloud/Tool provider
     */
    validation_only: boolean;

    /**
     * If set, it distributes settings to services
     */
    dispatcher: boolean;

}
